export const formTranslations = {
  // Search and input placeholders
  AskAQuestion: 'Ask a question... ',
  TypeSearchWord: 'Enter a search term',
  SearchWithinMySpace: 'Search within My Space',
  EnterSearchQuery: 'Enter a search term',
  EnterSearchQueryPlaceholder: 'Enter or edit your search query',
  SearchQueryInput: 'Enter or edit your search query',
  PleaseEnterTheWebsiteURL: 'Please enter the website URL',

  // Email form fields
  DraftEmail:
    'Please describe the email you hope to send. Based on this, we will create a draft.',
  EmailPlaceholder: 'Please paste your conversation history here',
  TemplateText: 'Template',
  EmailTone: 'Tone',
  EmailLanguage: 'Language',
  EmailThread: 'Email Thread',
  EmailAutomatic: 'Auto',
  EmailPoliteness: 'Polite',
  EmailFriendly: 'Casual',
  EmailConcise: 'Concise',

  // Draft and writing forms
  DraftTextFieldPlaceholder: 'Enter the text you would like to refine...',
  DraftTonePlaceHolder: 'Please describe your audience or desired tone',
  DraftDetailsTextFieldPlaceholder:
    'Please enter additional details. You can create content more accurately!',
  RefineCommandPlacerHolder: 'Enter Command',

  // Style and formatting options
  SentenceLength: 'Sentence length',
  DocumentLength: 'Document length',
  ToneNManner: 'Tone & Manner',
  Auto: 'Auto',
  Politeness: 'Politeness',
  Friendly: 'Friendly',
  Simple: 'Simple',
  Target: 'Target',
  Business: 'Business',
  Casual: 'Casual',
  Custom: 'Custom',

  // Length options
  VeryBriefly: 'Very briefly',
  Short: 'Brief',
  MaintainCurrentLength: 'Current length',
  Long: 'Detailed',
  VeryLong: 'Very long',
  Commonly: 'Standard',

  // Summary options
  Style: 'Style',
  Length: 'Depth',
  SummaryBasic: 'Paragraph',
  ThesisAbstract: 'Abstract',
  Grid: 'Bullet',
  Graph: 'Table',

  // Grammar and editing options
  Grammarcorrections: 'Grammar/typo corrections',
  SimpleFix: 'Simple fix',
  FullEdit: 'Full edit',
  AdditionalModifications: 'Additional modifications',

  // Workspace and project forms
  AddTitle: 'Add title',
  AddEmailandPressEnter: 'Add email and press enter',
  ChangeWorkspaceName: 'Change name',
  WorkSpaceSearch: 'Search',
  SearchProject: 'Search project',

  // Description fields
  DetailsTitle: 'Details',
  EnterDescriptionForTheKeyword:
    'Please enter a brief description for the keyword you want to generate',

  // Language selection
  ChooseLanguage: 'English',
  LanguageSearch: 'Language Search',

  // Invitation Toast
  InvitationSent: 'An invitation email has been sent!',
  InvitationReSent: 'The invitation email has been resent!',
}
